import { render } from "./DisqualificationRecord.vue?vue&type=template&id=0682bb1f&scoped=true"
import script from "./DisqualificationRecord.vue?vue&type=script&lang=js"
export * from "./DisqualificationRecord.vue?vue&type=script&lang=js"

import "./DisqualificationRecord.vue?vue&type=style&index=0&id=0682bb1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0682bb1f"]])

export default __exports__